import { authorizerTokenCookie } from '../types/authenticationContext.types';
import cookies from 'browser-cookies';

export const getBearerToken = (): string =>
	'Bearer ' + cookies.get(authorizerTokenCookie);

// Constant for backward compatibility
export const getBearerAuth0Token = getBearerToken;
